/**
 * @flow
 * @relayHash 9cda38464eecc5d1a7310226aa0e3eba
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RequestAccessToEventInput = {|
  email: string,
  eventId: string,
  language?: ?string,
  startnumber: string,
|};
export type RequestAccessToEventMutationVariables = {|
  input: RequestAccessToEventInput
|};
export type RequestAccessToEventMutationResponse = {|
  +requestAccessToEvent: ?{|
    +email: ?string,
    +status: ?string,
  |}
|};
export type RequestAccessToEventMutation = {|
  variables: RequestAccessToEventMutationVariables,
  response: RequestAccessToEventMutationResponse,
|};
*/


/*
mutation RequestAccessToEventMutation(
  $input: RequestAccessToEventInput!
) {
  requestAccessToEvent(input: $input) {
    email
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RequestAccessToEventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "requestAccessToEvent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestAccessToEventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RequestAccessToEventMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RequestAccessToEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "RequestAccessToEventMutation",
    "id": null,
    "text": "mutation RequestAccessToEventMutation(\n  $input: RequestAccessToEventInput!\n) {\n  requestAccessToEvent(input: $input) {\n    email\n    status\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ba6ff368e7140b5ef9aac39ec2e099b6';

module.exports = node;
